import React from 'react'
import SeoMeta from '../Common/SeoMeta'
import { Link } from 'react-router-dom'

const PorscheSForSaleInboerne = () => {
    return (
        <>
            <SeoMeta
                title="2012 Porsche 911 S For Sale in Boerne & Austin TX | 2012 Porsche 911 S Independent Dealer in Boerne & Austin TX | 2012 Porsche 911 S Specials in Boerne & Austin TX | 2012 Porsche 911 S in Boerne & Austin TX | 2012 Porsche 911 S For Sale Near Boerne & Austin TX"
                description="The 2012 Porsche 911 S for sale in Boerne, at Mark Motors was created to redefine the everyday driving experience, delivering exhilarating performance with surprising practicality. Experience the 2012 Porsche 911 S for sale in Boerne & Austin TX at Mark Motors!"
                keywords="2012 Porsche 911 S For Sale in Boerne & Austin TX, 2012 Porsche 911 S Independent Dealer in Boerne & Austin TX, 2012 Porsche 911 S Specials in Boerne & Austin TX, 2012 Porsche 911 S in Boerne & Austin TX, 2012 Porsche 911 S For Sale Near Boerne & Austin TX"
                ogTitle="2012 Porsche 911 S For Sale in Boerne & Austin TX | 2012 Porsche 911 S Independent Dealer in Boerne & Austin TX | 2012 Porsche 911 S Specials in Boerne & Austin TX | 2012 Porsche 911 S in Boerne & Austin TX | 2012 Porsche 911 S For Sale Near Boerne & Austin TX"
                ogDescription="The 2012 Porsche 911 S for sale in Boerne, at Mark Motors was created to redefine the everyday driving experience, delivering exhilarating performance with surprising practicality. Experience the 2012 Porsche 911 S for sale in Boerne & Austin TX at Mark Motors!"
            />
            <section className='cm-wrap pt-200'>
                <div className='container'>
                    <h1>2012 Porsche 911 S For Sale in Boerne, Texas at Mark Motors</h1>
                    <p>The 2012 Porsche 911 S for sale in Boerne, Texas at Mark Motors was created to redefine the everyday driving experience, delivering exhilarating performance with surprising practicality. The 2012 911 Porsche S for sale in Boerne, Texas has been developed with new, efficiency-enhancing technologies - Auto Start Stop, thermal management, and electrical system recuperation - that reduce fuel consumption while optimizing performance. Its first-ever seven-speed manual transmission allows for precise control of engine power while improving fuel efficiency. The 2012 911 Porsche S for sale in Boerne, Texas is one of several trim models - 911 Carrera, 911 Carrera S, 911 Carrera Cabriolet, and 911 Carrera S Cabriolet - as well as many exterior color options that include Carrera White, Racing Yellow, Guards Red, Black, Platinum Silver Metallic, Aqua Blue Metallic, Dark Blue Metallic, Ruby Red Metallic, Anthracite Brown Metallic, Agate Grey Metallic, Basalt Black Metallic, GT Silver Metallic, Lime Gold Metallic, and Cognac Metallic. Experience the 2012 Porsche 911 S for sale in Boerne, Texas at Mark Motors!</p>
                    <div className='mt-3'>
                        <Link to="/cars-for-sale-boerne-tx" className='btn-theme md-btn me-4 d-inline-block'>view inventory</Link>
                    </div>
                    <div className="widget-paragraph clearfix ">
                        <h2><span className="s1"><strong>Interior - 2012 Porsche 911 S For Sale in Boerne, TX</strong></span></h2>
                        <p>
                            The 2012 Porsche 911 S for sale in Boerne, Texas.
                            &nbsp;
                            <strong>Interior</strong>
                            Sport Seats Plus.
                            Adaptive Sport Seats Plus (18-way) with memory package including steering-column adjustment.
                            Seat heating, front.
                            Steering-wheel heating (only in conjunction with seat heating, front).
                            Seat ventilation (only in conjunction with seat heating, front).
                            Fire extinguisher.
                            Rev counter dial face in black.
                            &nbsp;
                            <strong>Interior - Leather</strong>
                            Multifunction steering wheel.
                            SportDesign steering wheel.
                            Leather seats.
                            Leather interior package in standard color.
                            Leather interior package in special color.
                            Leather interior package in two-one combination.
                            Leather interior package in natural leather.
                            Leather interior in color to sample.
                            &nbsp;
                            <span>Some features only available in select 2012 Porsche 911 S vehicles for sale in Boerne, Texas.</span>
                            &nbsp;
                            &nbsp;
                            &nbsp;
                            &nbsp;
                            <h2><span className="s1"><strong>Engine, Transmission, Chassis, &amp; Wheels - 2012 Porsche 911 S Independent Dealer in Boerne, Texas</strong></span></h2>
                            &nbsp;
                            The 2012 Porsche 911 S for sale in Boerne, Texas.
                            &nbsp;
                            <strong>Engine, Transmission, &amp; Chassis</strong>
                            Porsche Doppelkupplung (PDK, 7-speed).
                            Porsche Ceramic Composite Brakes (PCCB).
                            Porsche Active Suspension Management (PASM).
                            Porsche Torque Vectoring (PTV) with mechanically locking rear differential in conjunction with manual gearbox.
                            Porsche Torque Vectoring Plus (PTV Plus) with electronically locking rear differential in conjunction with optional PDK.
                            Sport Chrono Package.
                            Sport exhaust system.
                            Power Steering Plus.
                            &nbsp;
                            <strong>Wheels</strong>
                            20-inch Carrera S wheels.
                            20-inch SportDesign wheels.
                            20-inch Carrera Classic wheels.
                            Wheel centers with full-color Porsche Crest.
                            &nbsp;
                            <span>Some features only available in select 2012 Porsche 911 S vehicles for sale in Boerne, Texas.</span>
                        </p>
                        <div className='mt-3'>
                            <Link to="/cars-for-sale-boerne-tx" className='btn-theme md-btn me-4 d-inline-block'>view inventory</Link>
                        </div>
                        <div className="widget-paragraph clearfix ">
                            <h2><span className="s1"><strong>Technical Data - 2012 Porsche 911 S For Sale Near Boerne, TX</strong></span></h2>
                            <p>
                            The 2012 Porsche 911 S for sale in Boerne, Texas.
                            &nbsp;
                            <strong>Engine</strong>
                            Cylinders: 6.
                            Displacement: 3.4 liters.
                            Max power (DIN): 350 hp @ 7400 rpm.
                            Max torque: 287 lb-ft. @ 5600 rpm.
                            Compression ratio: 12.5:1.
                            &nbsp;
                            <strong>Transmission</strong>
                            Layout: Rear-wheel drive.
                            Manual gearbox: 7-speed.
                            PDK (optional): 7-speed.
                            &nbsp;
                            <strong>Chassis</strong>
                            Front axle: MacPherson strut suspension.
                            Rear axle: LSA multi-link suspension.
                            Steering: Variable-steering ratio, power-assist (electromechanical).
                            Turning circle: 36.4 ft.
                            Brakes: Four-piston, aluminum monobloc fixed calipers front and rear; discs internally vented and cross-drilled.
                            Vehicle stability system: Enhanced PSM (with ABS 8.0).
                            Anti-lock Brake System: ABS 8.0.
                            Standard wheels: Front: 8.5J x 19; Rear: 11J x 19.
                            Standard tires: Front: 235/40 ZR 19; Rear: 285/35 ZR 19.
                            </p>
                            <h2><span className="s1"><strong>Exterior Features - 2012 Porsche 911 S&nbsp; Specials in Boerne, TX</strong></span></h2>
                            <p>
                            The 2012 Porsche 911 S for sale in Boerne, Texas.
                            &nbsp;
                            Metallic paint.
                            Special colors.
                            Exterior color to sample.
                            Auto-dimming mirrors.
                            Electric tilt/slide sunroof.
                            Deletion of model designation.
                            ParkAssist (rear).
                            Rear wiper.
                            Roof Transport System.
                            Electrically folding exterior mirrors including courtesy lighting.
                            Window trim in high-class Aluminum.
                            &nbsp;
                            <span>Some features only available in select 2012 Porsche 911 S vehicles for sale in Boerne, Texas.</span>
                            </p>
                            <h2><span className="s1"><strong>Audio &amp; Communication - 2012 Porsche 911 S For Sale Near Boerne, TX</strong></span></h2>
                           <p>
                            The 2012 Porsche 911 S for sale in Boerne, Texas.
                            &nbsp;
                            HD Radio®&nbsp;receiver.
                            SiriusXM Satellite Radio®&nbsp;receiver.
                            Bose® Audio Package.
                            Burmester®&nbsp;Audio package.
                            &nbsp;
                            <span>Some features only available in select 2012 Porsche 911 S vehicles for sale in Boerne, Texas.</span>
                            &nbsp;
                            &nbsp;
                            <h2><span className="s1"><strong>Passion Meets Practicality - 2012 Porsche 911 S In Boerne, TX</strong></span></h2>
                            &nbsp;
                            <span>The 2012 Porsche 911 S for sale in Boerne, Texas at Mark Motors lets you take control to a new level. With its Porsche Active Suspension Management (PASM), Sports Chrono Package, Bi-Xenon™ headlights, Advanced LED technology, and many more features, the 2012 Porsche 911 S for sale in Boerne, Texas sets the bar for generations to come. Find your 2012 Porsche 911 S for sale in Boerne, Texas at Mark Motors today!</span>
                            &nbsp;
                            <span>Mark Motors proudly serves our customers in Boerne, San Antonio, Fredericksburg, and surrounding areas.</span>
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default PorscheSForSaleInboerne